import { Translatable } from '@app/types/translatable.type';

export const CompensationTypeDisplayOptions: { [key: string]: Translatable } = {
    Yearly: 'applicant-tracker.compensationTypes.yearly',
    Hourly: 'applicant-tracker.compensationTypes.hourly',
};
